export { default } from './ShowMoreFaqs';
